import type { RouteObject } from "react-router-dom";

export const conversionRoutes: RouteObject[] = [
  {
    handle: { breadcrumb: "Conversion" },
    async lazy() {
      const { Page } = await import("../app/page");
      return { element: <Page hidePadding={() => true} /> };
    },
    children: [
      {
        path: "hsa",
        handle: { breadcrumb: "HSA" },
        children: [
          {
            path: "payment-analytics",
            handle: { breadcrumb: "Payment analytics" },
            async lazy() {
              const { HsaPaymentAnalyticsPage } =
                await import("./hsa-payment-analytics-page");
              return { Component: HsaPaymentAnalyticsPage };
            },
          },
        ],
      },
      {
        path: "intent",
        handle: { breadcrumb: "Intent" },
        children: [
          {
            path: "trials",
            handle: { breadcrumb: "Self-serve trials" },
            async lazy() {
              const { IntentTrialsPage } = await import("./intent-trials-page");
              return { Component: IntentTrialsPage };
            },
          },
        ],
      },
    ],
  },
];
